
export enum VoiceoverStatus {
  Off, On, IntroOnly
}

export function swing(p: number) {
  return 0.5 - Math.cos(p * Math.PI) / 2;
}
